import { render, staticRenderFns } from "./dialogVuex.vue?vue&type=template&id=bc6eae60"
import script from "./dialogVuex.vue?vue&type=script&lang=js"
export * from "./dialogVuex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports